import { RBTEstado } from "./rbtestado";

export class RBTCampaignWithStates {
    id:string;
    name:string;
    estados: RBTEstado[]=[];
}